import { AlpineComponent } from "alpinejs";
import { PasswordResetService } from "../api";

type ForgotPassword = AlpineComponent<{
	email: string;
	showErrorMessage: boolean;
	showSuccessMessage: boolean;
	submissionErrors: string[];
	sendEmail: () => void;
}>;

export default (): ForgotPassword => {
	return {
		email: "",
		showErrorMessage: false,
		showSuccessMessage: false,
		submissionErrors: [],
		async sendEmail() {
			const response = await PasswordResetService.sendPasswordResetMail({
				body: { email: this.email, contentId: Number(document.documentElement?.dataset?.contentId) },
			});
			this.submissionErrors = [];
			if (response.response.ok) {
				this.showSuccessMessage = true;
				this.showErrorMessage = false;
			} else {
				if (response.error != null) {
					for (const error of response.error) {
						this.submissionErrors.push(error);
					}
				}
				this.showErrorMessage = true;
				this.showSuccessMessage = false;
			}
		},
	};
};
